module.exports = __webpack_public_path__ + "img/4_121.5b3bc1a0.png";